import axios from 'axios';

const userToken = localStorage.getItem('userToken');

const api = axios.create({
    baseURL:"http://api.florescer.b2ml.com.br:15200/api",
    headers: {'Authorization': `Bearer ${userToken}`}
});
    
export default api;